module.exports = {
	"id": "/enet_event_match_day",
	"type": "object",
	"properties": {
		"sportId": {
			"type": "integer",
			"required": true
		},
		"tournamentId": {
			"type": "integer",
			"required": true
		},
		"eventId": {
			"type": "integer",
			"required": true
		},
		"homeId": {
			"type": "integer",
			"required": true
		},
		"awayId": {
			"type": "integer",
			"required": true
		}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ../src/config/message_schemas/triggers/enet_event_match_day.json
 ** module id = 1826
 ** module chunks = 0
 **/